import styled from 'styled-components'
import { COLOR, FONT_SIZE, SIDE_BAR, TOPBAR_SIZE } from '../../themes'

export const StyleListFloor = styled.div`
  color: ${COLOR.BLACK_1};
  height: 100vh;
  position: absolute;
  top: 0;
  left: ${SIDE_BAR.WIDTH_SIZE};
  right: 0;
  bottom: 0;

  .date{
    float: right;
  }
  .content {
    max-height: 982px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 20px;
    overflow: auto;
    height: calc(100% - 98px);
    margin-top: ${TOPBAR_SIZE.LV_1};
    background-color: ${COLOR.WHITE};
    display: flex;
    flex-direction: column;
  }

  .tabs-container {
    display: flex;
    width: calc(100% + 64px);
    margin-top: 16px;
    margin-left: -32px;
    margin-right: -32px;
    margin-bottom: 32px;
  }
  
  .tab-item {
    flex: 1;
    text-align: center;
    padding: 12px 0;
    cursor: pointer;
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XXS};
    font-weight: 700;
  }
  
  .tab-active {
    color: ${({ colorTheme }) => colorTheme || COLOR.BROWN_1};
    border-bottom: 2px solid ${({ colorTheme }) => colorTheme || COLOR.BROWN_1};
  }
  
  .tab-inactive {
    color: ${COLOR.GRAY_25};
    border-bottom: 1px solid ${COLOR.GRAY_26};
  }

  .building-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .building-title {
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.XL};
    font-weight: 700;
    color: ${COLOR.BLACK_5};
  }

  .filter-bar {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
    margin-bottom: 32px;
  }
  
  .filter-row {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .filter-input-container {
    display: flex;
    align-items: center;
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    padding: 0 16px;
    height: 48px;
    box-sizing: border-box;
    background-color: ${COLOR.WHITE};
    min-width: 200px;
    flex: 1;
  }

  .filter-input-container.search {
    flex: 2;
  }

  .filter-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  .filter-icon-right {
    width: 20px;
    height: 20px;
    margin-left: 8px;
  }

  .filter-input {
    border: none;
    outline: none;
    flex: 1;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    padding: 0 0 3px 0;
    margin: 0;
    line-height: 1.5;
  }

  .filter-input::placeholder {
    color: ${COLOR.GRAY_27};
    font-size: 18px;
    padding: 3px 0;
  }

  .filter-select {
    border: none;
    outline: none;
    flex: 1;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.TN};
    font-weight: 400;
    color: ${COLOR.BLACK_5};
    background: transparent;
    appearance: none;
    line-height: 1;
  }

  .clear-filter-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    padding: 0 16px;
    height: 48px;
    box-sizing: border-box;
    background-color: ${COLOR.WHITE};
    cursor: pointer;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    line-height: 1;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  }
  .clear-filter-btn:hover {
    background-color: ${COLOR.GRAY_21};
    border-color: ${COLOR.GRAY_21};
  }
  .clear-filter-btn:active {
    background-color: ${COLOR.GRAY_5};
    border-color: ${COLOR.GRAY_5};
  }

  .company {
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.XXXL};
    margin-top: 20px;
  }

  .notFound {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${COLOR.GRAY_3};
  }

  .dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }
  .building-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: ${COLOR.WHITE};
    box-shadow: none;
    border-radius: 8px;
    border: 1.5px solid ${COLOR.GRAY_5};
    z-index: 1000;
    min-width: 240px;
    padding: 0;
    margin-top: 12px;
    overflow-y: auto;
    max-height: 240px;
  }
  .dropdown-option {
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    cursor: pointer;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
  }
  .building-option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .building-header-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  .building-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
`
